import(/* webpackMode: "eager" */ "/www/wwwroot/MikroPay/src/app/page.tsx")